import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as schedulerApi from '../../api/scheduler';

export const fetchSchedulerTasks = createAsyncThunk(
    'scheduler/fetchTasks',
    async (_, { rejectWithValue, getState }) => {
        const { auth } = getState();
        const tenantId = auth.activeTenant?.tenant_id;
        try {
            return await schedulerApi.fetchSchedulerTasks({ tenantId });
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const triggerSchedulerTask = createAsyncThunk(
    'scheduler/triggerTask',
    async ({ dataSourceId }, { rejectWithValue, getState }) => {
        const { auth } = getState();
        const tenantId = auth.activeTenant?.tenant_id;
        try {
            return await schedulerApi.triggerSchedulerTask(dataSourceId, { tenantId });
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const updateSchedulerTask = createAsyncThunk(
    'scheduler/updateTask',
    async ({ dataSourceId, preset }, { rejectWithValue, getState }) => {
        const { auth } = getState();
        const tenantId = auth.activeTenant?.tenant_id;
        try {
            return await schedulerApi.updateSchedulerTask(dataSourceId, { preset }, { tenantId });
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchSchedulerTaskRuns = createAsyncThunk(
    'scheduler/fetchTaskRuns',
    async ({ dataSourceId, limit = 20 }, { rejectWithValue, getState }) => {
        const { auth } = getState();
        const tenantId = auth.activeTenant?.tenant_id;
        try {
            const runs = await schedulerApi.fetchSchedulerTaskRuns(dataSourceId, limit, { tenantId });
            return { dataSourceId, runs };
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const schedulerSlice = createSlice({
    name: 'scheduler',
    initialState: {
        tasks: [],
        runsByDataSource: {},
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSchedulerTasks.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSchedulerTasks.fulfilled, (state, action) => {
                state.loading = false;
                state.tasks = action.payload || [];
            })
            .addCase(fetchSchedulerTasks.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(updateSchedulerTask.fulfilled, (state, action) => {
                const updated = action.payload;
                const idx = state.tasks.findIndex(t => t.data_source_id === updated.data_source_id);
                if (idx >= 0) {
                    state.tasks[idx] = { ...state.tasks[idx], ...updated };
                } else {
                    state.tasks.push(updated);
                }
            })
            .addCase(fetchSchedulerTaskRuns.fulfilled, (state, action) => {
                const { dataSourceId, runs } = action.payload;
                state.runsByDataSource[dataSourceId] = runs;
            });
    },
});

export default schedulerSlice.reducer;
